export class EndPageView {

    winnerMessage = document.querySelector<HTMLElement>('.endpage')!;

}